export const selectedColor = "#cc0d0d";
export const textColor = "#000000";
